
import HeaderPart from './components/HeaderPart.vue';
import FooterPart from './components/FooterPart.vue';
import Helpers from './helpers';

export default({
  name: 'App',
  components: {
    HeaderPart, 
    FooterPart
  }
});

// Preload heavy images or gifs that are used in other pages
Helpers.preloadImages([
  "img/projects/project-1-icon.png",
  "img/projects/project-2-icon.png",
  "img/projects/project-3-icon.png"
]);

